import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Home } from 'lucide-react';

const OrderCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-50 flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full">
        <CardContent className="p-12 text-center">
          {/* Cancelled Icon */}
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
              <XCircle className="w-12 h-12 text-orange-600" />
            </div>
          </div>

          {/* Message */}
          <h1 className="text-3xl font-bold text-slate-900 mb-4">
            Order Cancelled
          </h1>
          <p className="text-lg text-slate-600 mb-8">
            Your order was not completed. No charges were made to your account.
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left">
            <p className="text-sm text-blue-900 mb-2">
              Your selected items are still saved and available. You can return to complete your order at any time.
            </p>
            <p className="text-sm text-blue-700">
              If you experienced any issues during checkout, please contact us at support@edutracker.app
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              size="lg"
            >
              <Home className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
            <Button
              onClick={() => navigate('/order-stickers')}
              size="lg"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Return to Order
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OrderCancelledPage;
